import type { Sparte } from '@/features/Global/types';
import { VglError } from '@/services/errorHandler/vglError';
import { VGL_ERROR_CODE } from '@/services/errorHandler/errorCodes';

export abstract class AbstractRequirementMapper {
  protected frontendKey: null | string | Map<string, string> = null;

  private readonly apiKey: string;

  protected values: any[];

  constructor(apiKey: string, values: any[]) {
    this.apiKey = apiKey;
    this.values = values;
  }

  public getFrontendKey(sparte: Sparte): string {
    if (typeof this.frontendKey === 'string') {
      return this.frontendKey;
    }

    if (this.frontendKey !== null) {
      if (!this.frontendKey.has(sparte)) {
        throw new VglError(
          VGL_ERROR_CODE.COMPANY_QUESTION_MISSING_FRONTEND_KEY_FOR_SPARTE,
          {
            additionalData: {
              sparte,
              apiKey: this.apiKey,
              frontendKey: Object.fromEntries(this.frontendKey),
            },
          },
        );
      }
      return this.frontendKey.get(sparte) ?? this.apiKey;
    }

    return this.apiKey;
  }

  public getValues(): any[] {
    return this.values;
  }
}
